import { useLocation } from 'react-router';

function useQuery<T extends string>(parameter: T) {
    return new URLSearchParams(useLocation().search).get(parameter);
}

export default useQuery;
